export enum UserResponseChangeOrgIdError {}
